import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
// import ReactDom from 'react-dom';
import qs from 'qs';
import './styles.scss';
import {pcaa} from 'area-data';
import {AreaSelect, AreaCascader} from 'react-area-linkage';
import Page from '../../components/page/page';
import styles from './style.css';
import {update} from '../../api/user';
import {setUser} from '../../reducers/teach';
import message from "../../components/message/message";
import {setCourse} from '../../reducers/teach';
import {saveLessonRecord} from "../../api/lesson-record";
import {getCourse} from '../../api/course';
import {saveCourseRecord} from "../../api/course-record";


class Competition extends React.PureComponent {
    constructor(props) {
        super(props);
        this.getCourse = this.getCourse.bind(this);
        this.query = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getCourse()
    }

    componentWillReceiveProps(props) {
        this.setState({
            name: props.user && props.user.name,
            phone: props.user && props.user.phone,
            district: props.user.district,
            province: props.user.province,
            city: props.user.city,
            school: props.user && props.user.school
        })
    }

    getCourse() {
        getCourse(this.query, {quiet: !!this.props.course.id}).then(res => {
            this.props.setCourse(res)
            if (res.record && res.lessons && !res.lessons[0].record) { //解锁第一课
                saveLessonRecord({
                    course_record_id: res.id,
                    lesson_id: res.lessons[0].id
                }).then();
            }
        });
    }

    selectedChange(e) {
        this.setState({
            province: e[0],
            city: e[1],
            district: e[2]
        })
    }

    changeName(e) {
        const {value} = e.target
        this.setState({
            name: value,
        })
    }

    changePhone(e) {
        const {value} = e.target
        this.setState({
            phone: value,
        })
    }

    changeSchool(e) {
        const {value} = e.target
        this.setState({
            school: value,
        })
    }

    handleLoginSuccess(user) {
        setUser(user);
        this.joinCourse()
        // message.show(window.L('teach.user.saveSuccess'));
    }

    async handleSubmit() {
        const {name, phone, province, city, district, school} = this.state
        try {
            let user = await update({
                name, phone, province, city, district, school,
            },{quiet: !!this.props.course.id});
            this.handleLoginSuccess(user);
        } catch (error) {
            // eslint-disable-next-line no-alert
            if (error.msg || error.data) {
                message.show(error.msg.name || error.data);
            } else {
                message.show(error.toString());
            }
        }
    }

    joinCourse(){
        const {course,history} = this.props
        let data = {
            course_id: course.id,
            clazz_id: course.clazz_course.clazz_id,
            clazz_code: course.clazz_course.clazz.code
        };
        saveCourseRecord(data, {showLoading: window.L("teach.loading.submit")}).then(
            () => {
                message.show(window.L('teach.course.joinSuccess'));
                // history.push(`/course?id=${course.id}&clazz_id=${course.clazz_course.clazz_id}`)
                history.go(-1)
            }
        );
    };

    render() {
        const {user} = this.props

        let areaArray = []
        if (user.id) {
            areaArray = [user.province.toString(), user.city.toString(), user.district.toString()]
        }
        return (
            <Page title="填写报名信息" isModal={true}>
                <div className={styles.formBox}>
                    <div className={styles.formItem}>
                        <label>姓名：</label>
                        <input defaultValue={user.name || ''} onChange={e => this.changeName(e)}></input>
                    </div>
                    <div className={styles.formItem}>
                        <label>手机号：</label>
                        <input defaultValue={user.phone || ''} onChange={e => this.changePhone(e)}></input>
                    </div>
                    <div className={styles.formItem}>
                        <label>地区选择：</label>
                        <AreaSelect level={2} defaultArea={areaArray} onChange={(e) => this.selectedChange(e)} data={pcaa} />
                    </div>
                    <div className={styles.formItem}>
                        <label>学校名称：</label>
                        <input style={{width: '500px'}} defaultValue={user.school || ''} onChange={e => this.changeSchool(e)}></input>
                    </div>
                    <div className={styles.formSubmit}>
                        <button onClick={this.handleSubmit}>确认报名</button>
                    </div>
                </div>
            </Page>
        )
    }

}

Competition.propTypes = {
    course: PropTypes.object,
    setCourse: PropTypes.func,
    location: PropTypes.object,
}

const mapStateToProps = state => ({
    user: state.teach.user,
    course: state.teach.course,
});

const mapDispatchToProps = dispatch => ({
    setCourse: course => dispatch(setCourse(course)),
});

export default connect(
    mapStateToProps, mapDispatchToProps
)(Competition);